import script from "./activityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./activityPage.vue?vue&type=script&setup=true&lang=js"

import "./activityPage.vue?vue&type=style&index=0&id=8c74b23c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c74b23c"]])

export default __exports__